import React from "react";
import Product from "./Product/Product.view";
import { isProductDisabled } from "../../../utils";
import _ from "lodash";
import { OFFER_SECTION_KEY, PRODUCT_STYLE_GRID } from "../../../constants";
import { ResponsiveGrid } from "@dishopsaas/design-system";
import { ProductListProps } from "../../../1_types/productTypes";
import { useAppSelector } from "../../../redux/hook";

export default function ProductList({
  section,
  messages,
  isLoading,
}: ProductListProps) {
  const { productStyle } = useAppSelector(
    (state) => state.configurationReducer,
  );

  if (isLoading) {
    const isVertical = productStyle === PRODUCT_STYLE_GRID;
    return (
      <ResponsiveGrid vertical={isVertical}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Product
            key={`skeleton-${index}`}
            isVertical={isVertical}
            isLoading={isLoading}
          />
        ))}
      </ResponsiveGrid>
    );
  }

  if (!section || _.isEmpty(section.products)) {
    return null;
  }
  const filteredSection = () => {
    return _.keys(section.products)
      .sort((a, b) => {
        const productA = section.products[a];
        const productB = section.products[b];
        if (productA && productB) {
          const positionA = isProductDisabled(productA)
            ? 70 + productA.position
            : productA.position;
          const positionB = isProductDisabled(productB)
            ? 70 + productB.position
            : productB.position;
          return positionA - positionB;
        }
        return 0;
      })
      .filter((key) => !section.products[key].hidden);
  };

  const productsKeys = filteredSection();
  if (productsKeys.length === 0) return null;

  const isOfferSection = section.key === OFFER_SECTION_KEY;
  const isVertical = productStyle === PRODUCT_STYLE_GRID && !isOfferSection;
  return (
    <ResponsiveGrid vertical={isVertical}>
      {productsKeys.map((key) => {
        const product = section.products[key];
        const cardImage = product.imageCompressed || product.image;

        return (
          <Product
            product={product}
            cardImage={cardImage}
            sectionKey={isOfferSection ? product.sectionKey : section.key}
            sectionName={isOfferSection ? product.sectionName : section?.name}
            isOfferSection={isOfferSection}
            messagesSectionRange={messages}
            isVertical={isVertical}
          />
        );
      })}
    </ResponsiveGrid>
  );
}
